module.exports = __webpack_public_path__ + "media/src/assets/images/lps-hobby-2971d77d64923b86bc3a6f5ed342e418.png";